var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"train-grade"},[_c('el-header',[_c('span',{staticClass:"back-btn",on:{"click":_vm.back}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v("返回")])]),_c('el-main',[_c('Mark')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }